import { setLoading } from '@/util/helpers';
import { apiClient } from '@/util/resources';
import { silentLogout } from '@/util/expert/auth';
import router from '@/router/expert';
import { RESPONSE_ERROR_CODE_LIST } from '@/config/constants';

// Request interceptor
apiClient.interceptors.request.use((config) => {
    setLoading(true);

    return config;
}, (error) => {
    setLoading(false);
    console.log('RequestError: ', error.response);
    // Do something with request error
    return Promise.reject(error);
});

// Response interceptor
apiClient.interceptors.response.use((response) => {
    setLoading(false);
    return response;
}, (error) => {
    setLoading(false);
    console.log('ResponseError: ', error.response);

    if (error.response.status === 401 && router.currentRoute.name !== 'login') {
        silentLogout();
    }

    // Default error
    let errorObj = {
        httpCode: error.response.status,
        errorCode: null,
        message: RESPONSE_ERROR_CODE_LIST.default,
    };

    // errorCode IN [500, 404]
    if ([500, 404].includes(error.response.status) && typeof error.response.data === 'string') {
        if (_.has(RESPONSE_ERROR_CODE_LIST, error.response.status)) {
            errorObj.message = RESPONSE_ERROR_CODE_LIST[error.response.status];
        } else {
            errorObj.message = error.response.statusText;
        }
    } else {
        errorObj.errorCode = error.response.data.errorCode;

        /* eslint-disable no-lonely-if */
        if (_.has(RESPONSE_ERROR_CODE_LIST, error.response.data.errorCode)) {
            errorObj.message = RESPONSE_ERROR_CODE_LIST[error.response.data.errorCode];
        } else {
            errorObj.message = error.response.data.message;
        }
    }

    return Promise.reject(errorObj);
});
